import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { Form } from 'ui/components';

import { DatePicker, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';

const initialState = {
  type: null,
  moda_type: null,
  shipping_method: 'inhouse',
  schedule_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  vendor: null,
  origin: null,
  destination: null,
  isLoading: true,
  total_cost: 0,
  is_with_console: false,
};

const shippingOption = [
{
  value: 'inhouse',
  label: 'Inhouse',
},
  {
    value: 'external',
    label: 'Forward',
  },
];

const typeOptions = [
  {
    value: 'pickup',
    label: 'First Mile',
  },
  {
    value: 'console',
    label: 'Mid Mile',
  },
  {
    value: 'last_mile',
    label: 'Last Mile',
  },
  {
    value: 'return',
    label: 'Return',
  },
];

const modaOptions = [
  {
    value: 'land_freight',
    label: 'Darat',
  },
  {
    value: 'sea_freight',
    label: 'Laut',
  },
  {
    value: 'air_freight',
    label: 'Udara',
  },
];

export const FormGeneral = ({ onValueChange, initialValue, onUpdate }) => {
  const StateForm = useSelector((state) => state?.Form);
  const Session = useSelector((state) => state?.Auth?.session);

  const [
    {
      type,
      moda_type,
      shipping_method,
      schedule_at,
      vendor,
      origin,
      destination,
      total_cost,
      is_with_console,
      isLoading,
    },
    setState,
  ] = React.useState(initialState);

  const $handleTypeChanges = (e) => {
    let prevType = type;

    setState((prevState) => ({
      ...prevState,
      type: e,
      origin: prevType !== e ? null : origin,
      destination: prevType !== e ? null : destination,
    }));
  };

  const $handleModaChanges = (e) => {
    setState((prevState) => ({ ...prevState, moda_type: e }));
  };

  React.useEffect(() => {
    const value = {
      vendor_id: vendor?.id,
      type: type?.value,
      moda_type: moda_type?.value,
      shipping_method,
      schedule_at: schedule_at?.formatted,
      origin: origin,
      destination: destination,
      total_cost: total_cost,
      is_with_console,
    };

    onValueChange(value);
  }, [
    vendor,
    type,
    moda_type,
    shipping_method,
    schedule_at,
    origin,
    total_cost,
    destination,
    is_with_console,
  ]);

  React.useEffect(() => {
    if (!shipping_method) return;

    if (shipping_method === 'external' && !initialValue) {
      setState({
        type: {value: 'forwarder'},
        moda_type: null,
        schedule_at: {
          default: new Date(),
          formatted: formatDate(new Date(), 'YYYY-MM-DD'),
        },
        vendor: null,
        shipping_method: 'external',
      });
    }
  }, [shipping_method]);

  React.useLayoutEffect(() => {
    if (!initialValue) return;

    let t =
      initialValue?.type === 'pickup'
        ? typeOptions[0]
        : initialValue?.type === 'console'
        ? typeOptions[1]
        : initialValue?.type === 'last_mile'
        ? typeOptions[2]
        : initialValue?.type === 'return'
        ? typeOptions[3]
        : {value: 'forwarder'};

    let mt =
      initialValue?.moda_type === 'land_freight' || initialValue?.console?.moda_type === 'land_freight'
        ? modaOptions[0]
        : initialValue?.moda_type === 'sea_freight' || initialValue?.console?.moda_type === 'sea_freight'
        ? modaOptions[1]
        : initialValue?.moda_type === 'air_freight' || initialValue?.console?.moda_type === 'air_freight'
        ? modaOptions[2]
        : null;

    setState((prevState) => ({
      ...prevState,
      type: t,
      moda_type: mt,
      schedule_at: {
        default: new Date(initialValue?.schedule_at),
        formatted: formatDate(initialValue?.schedule_at, 'YYYY-MM-DD'),
      },
      vendor: initialValue?.vendor,
      shipping_method: initialValue?.shipping_method,
      origin: initialValue?.origin,
      destination: initialValue?.destination || initialValue?.console?.destination,
      total_cost: initialValue?.total_cost,
      is_with_console: initialValue?.is_with_console,
    }));
  }, [initialValue]);

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  return isLoading ? (
    <div className="mt-3 p-3 ">
      <SkeletonsForm count={5} />
    </div>
  ) : (
    <div className="p-3 h-100">
      <div className="mb-3 border-bottom pb-3">
        <label className="form-label fs-8 required">Tipe Dispatch</label>
        <div className="mt-2 d-flex flex-wrap align-items-center">
          {shippingOption?.map((t, i) => (
            <div className="text-center position-relative w-50" key={i} disabled={onUpdate}>
              <label
                className={cn(
                  'service-radio-image border rounded-2 d-flex flex-column flex-wrap align-items-center justify-content-center py-2',
                  StateForm?.errors?.shipping_method ? 'border-danger' : '',
                  onUpdate ? '': 'service-radio-image-hover cursor-pointer'
                )}
              >
                {shipping_method === t?.value && (
                  <div
                    className="position-absolute h-100 w-100 border border-primary border-1 rounded-2 d-flex flex-wrap align-items-center justify-content-start"
                    style={{ zIndex: 2 }}
                  >
                    <div className="ms-2 ">
                      <Fi.FiCheckCircle size={20} color="#2f83ba" />
                    </div>
                  </div>
                )}

                <input
                  type="radio"
                  name="layout"
                  onChange={() => {
                    setState((prevState) => ({
                      ...prevState,
                      shipping_method: t?.value,
                      type: t?.value === 'external' ? {value: 'forwarder'}: null
                    }));
                  }}
                  disabled={onUpdate}
                />
                <div
                  className={cn(
                    'page-pretitle fs-8 ms-1',
                    shipping_method === t?.value ? 'text-primary' : ''
                  )}
                >
                  {t?.label}
                </div>
              </label>
            </div>
          ))}
        </div>

        {StateForm?.errors?.shipping_method && (
          <div className="invalid-feedback" style={{ display: 'block' }}>
            {StateForm?.errors?.shipping_method}
          </div>
        )}
      </div>

      <div className="row">
        {shipping_method === 'inhouse' ? (
          <>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label fs-8 required">Pilih Tipe</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.type ? 'is-invalid' : 'select'
                  }
                  placeholder=""
                  value={type}
                  options={typeOptions}
                  isDisabled={onUpdate}
                  onChange={$handleTypeChanges}
                />

                {StateForm?.errors?.type ? (
                  <div className="invalid-feedback d-block ">
                    {StateForm?.errors?.type}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label fs-8 required">Moda</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.moda_type ? 'is-invalid' : 'select'
                  }
                  placeholder=""
                  value={moda_type}
                  options={modaOptions}
                  onChange={$handleModaChanges}
                />

                {StateForm?.errors?.moda_type ? (
                  <div className="invalid-feedback d-block ">
                    {StateForm?.errors?.moda_type}
                  </div>
                ) : null}
              </div>
            </div>

            {Session?.hub === undefined ? (
              <>
                {(type?.value === 'last_mile' ||
                  type?.value === 'console' ||
                  type?.value === 'return' || type?.value === 'forwarder') && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Select.Remote
                        label="Pilih Asal"
                        required
                        isSearch={false}
                        placeholder=""
                        url="/location/hub"
                        params={{ type: 'hub', is_active: 1 }}
                        initialValue={initialValue?.origin?.id || origin?.id}
                        row={(d) => {
                          return { value: d.id, label: d.name };
                        }}
                        onSelected={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            origin: e,
                          }))
                        }
                        disabled={onUpdate}
                        errors={StateForm?.errors?.origin_id}
                        keys={type?.value}
                      />
                    </div>
                  </div>
                )}

                {(type?.value === 'pickup' || type?.value === 'console') && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Select.Remote
                        label="Pilih Tujuan"
                        required
                        isSearch={false}
                        placeholder=""
                        url="/location/hub"
                        params={{ type: 'hub', is_active: 1 }}
                        initialValue={
                          initialValue?.destination?.id || destination?.id
                        }
                        row={(d) => {
                          return { value: d.id, label: d.name };
                        }}
                        onSelected={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            destination: e,
                          }))
                        }
                        disabled={onUpdate}
                        errors={StateForm?.errors?.destination_id}
                        keys={type?.value}
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              type?.value === 'console' && (
                <div className="col-md-6">
                  <div className="mb-3">
                    <Select.Remote
                      label="Pilih Tujuan"
                      required
                      isSearch={false}
                      placeholder=""
                      url="/location/hub"
                      params={{ type: 'hub', is_active: 1 }}
                      initialValue={
                        initialValue?.destination?.id || destination?.id
                      }
                      row={(d) => {
                        return { value: d.id, label: d.name };
                      }}
                      onSelected={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          destination: e,
                        }))
                      }
                      disabled={onUpdate}
                      errors={StateForm?.errors?.destination_id}
                      keys={type?.value}
                    />
                  </div>
                </div>
              )
            )}
          </>
        ): (
          <>
            {Session?.hub === undefined && (
              <div className="col-md-6">
                <div className="mb-3">
                  <Select.Remote
                    label="Pilih Asal"
                    required
                    isSearch={false}
                    placeholder=""
                    url="/location/hub"
                    params={{ type: 'hub', is_active: 1 }}
                    initialValue={initialValue?.origin?.id || origin?.id}
                    row={(d) => {
                      return { value: d.id, label: d.name };
                    }}
                    onSelected={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        origin: e,
                      }))
                    }
                    disabled={onUpdate}
                    errors={StateForm?.errors?.origin_id}
                    keys={type?.value}
                  />
                </div>
              </div>
            )}
          </>
        )}

        {shipping_method && (
          <div className="col-md-6">
            <div className="mb-3">
              <Select.Remote
                required={shipping_method === 'external'}
                label="Pilih Vendor"
                placeholder=""
                url="/partner"
                params={{"type": 'vendor'}}
                value={vendor}
                initialValue={vendor?.id}
                keys={vendor?.id}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d.name,
                  };
                }}
                onSelected={(c) => {
                  setState((prevState) => ({
                    ...prevState,
                    vendor: c,
                  }));
                }}
                errors={StateForm?.errors?.vendor_id}
              />
            </div>
          </div>
        )}

        {type?.value === 'forwarder' && (
          <>
            <div className='col-md-6'>
              <Form.Checkbox
                value={is_with_console}
                onChange={(e) => {
                  if (!is_with_console) {
                    setState((prevState) => ({
                      ...prevState,
                      is_with_console: true,
                    }));
                  } else {
                    setState((prevState) => ({
                      ...prevState,
                      is_with_console: false,
                    }));
                  }
                }}
                iconSize={18}
                label="Manifest Midmile"
              />
              {is_with_console && (
                <div className="mb-3 mt-2">
                  <Select.Remote
                    label="Pilih Tujuan"
                    required
                    isSearch={false}
                    placeholder=""
                    url="/location/hub"
                    params={{ type: 'hub', is_active: 1 }}
                    initialValue={
                      initialValue?.destination?.id || destination?.id
                    }
                    row={(d) => {
                      return { value: d.id, label: d.name };
                    }}
                    onSelected={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        destination: e,
                      }))
                    }
                    disabled={onUpdate}
                    errors={StateForm?.errors?.destination_id}
                    keys={type?.value}
                  />
                </div>
              )}
            </div>

            {is_with_console && (
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label fs-8 required">Moda</label>
                  <Select
                    isClearable
                    classNamePrefix={
                      StateForm?.errors?.moda_type ? 'is-invalid' : 'select'
                    }
                    placeholder=""
                    value={moda_type}
                    options={modaOptions}
                    onChange={$handleModaChanges}
                  />

                  {StateForm?.errors?.moda_type ? (
                    <div className="invalid-feedback d-block ">
                      {StateForm?.errors?.moda_type}
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </>
        )}

        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label required">Pilih Jadwal</label>
            <div
              className={
                StateForm?.errors?.schedule_at
                  ? 'border border-danger rounded'
                  : ''
              }
            >
              <DatePicker
                type="normal"
                value={schedule_at?.default}
                format="dd/MM/yyyy"
                onChange={(date) => {
                  setState((prevState) => ({
                    ...prevState,
                    schedule_at: {
                      default: date,
                      formatted: formatDate(date, 'YYYY-MM-DD'),
                    },
                  }));
                }}
                isShowTrigger
                error={StateForm?.errors?.schedule_at}
              />
            </div>

            {StateForm?.errors?.schedule_at ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.schedule_at}
              </div>
            ) : null}
          </div>
        </div>

        <div className="col-md-6">
          <Form.Input
            value={total_cost}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                total_cost: e.target.valueNumber,
              }))
            }
            type="number"
            label="Harga Pengiriman"
            error={StateForm?.errors?.total_cost}
          />
        </div>
      </div>
    </div>
  );
};
